import { signal } from "@preact/signals-react";

type Theme = "light" | "dark";
const storageKey = "hoh.theme";

function readTheme(): Theme {
    try {
        return localStorage.getItem(storageKey) === "dark" ? "dark" : "light";
    } catch {
        return "light";
    }
}

export const theme = signal<Theme>(readTheme());

export function initializeTheme() {
    document.documentElement.dataset.theme = theme.value;
}

export function toggleTheme() {
    theme.value = theme.value === "dark" ? "light" : "dark";
    initializeTheme();
    try {
        localStorage.setItem(storageKey, theme.value);
    } catch {
        // The theme still works when browser storage is unavailable.
    }
}
